module.exports = __webpack_public_path__ + "img/28_80.1c70a644.png";